// AuditLogTable.tsx
import React from 'react'
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Collapse,
  Box,
  IconButton,
  Typography,
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp'

const useRowStyles = makeStyles({
  root: {
    '& > *': {
      borderBottom: 'unset',
    },
  },
})

type FieldChange = {
  ReadableFieldName: string
  OldValue: string
  NewValue: string
}

type AuditLogItem = {
  eventID: string
  ActionDate: string
  Action: string
  ModifiedByUserName?: string
  CreatedByUserName?: string
  FieldChanges: FieldChange[]
}

function Row({ row }: { row: AuditLogItem }) {
  const [open, setOpen] = React.useState(false)
  const classes = useRowStyles()

  return (
    <>
      <TableRow className={classes.root}>
        <TableCell>
          <IconButton size="small" onClick={() => setOpen(!open)}>
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell>{new Date(row.ActionDate).toLocaleString()}</TableCell>
        <TableCell>{row.Action}</TableCell>
        <TableCell>{row.ModifiedByUserName || '-'}</TableCell>
        <TableCell>{row.CreatedByUserName || '-'}</TableCell>
        <TableCell
          style={{ color: 'blue', cursor: 'pointer' }}
          onClick={() => setOpen(!open)}
        >
          {open ? 'Hide' : 'View'} ({row.FieldChanges.length})
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell colSpan={6} style={{ paddingBottom: 0, paddingTop: 0 }}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box margin={1}>
              <Typography variant="subtitle1" gutterBottom>
                Field Changes
              </Typography>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Field</TableCell>
                    <TableCell>Old Value</TableCell>
                    <TableCell>New Value</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {row.FieldChanges.map((field, idx) => (
                    <TableRow key={idx}>
                      <TableCell>{field.ReadableFieldName}</TableCell>
                      <TableCell style={{ color: 'red' }}>
                        {field.OldValue}
                      </TableCell>
                      <TableCell style={{ color: 'green' }}>
                        {field.NewValue}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  )
}

export default function AuditLogTable({
  auditLogs,
}: {
  auditLogs: AuditLogItem[]
}) {
  return (
    <TableContainer component={Paper}>
      <Table aria-label="Audit Log Table">
        <TableHead>
          <TableRow>
            <TableCell />
            <TableCell>Date</TableCell>
            <TableCell>Action</TableCell>
            <TableCell>Modified By</TableCell>
            <TableCell>Created By</TableCell>
            <TableCell>Changes</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {auditLogs.map(log => (
            <Row key={log.eventID} row={log} />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}
